// extracted by mini-css-extract-plugin
export default {"addedPill":"AddedPill_addedPill__l4Lsr","checkInPill":"AddedPill_checkInPill__rWNZH"};